'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrackPayload = exports.TRACK_EVENT = exports.usageTrackerActions = exports.usageTrackerMiddleware = undefined;

var _middleware = require('./middleware');

var _middleware2 = _interopRequireDefault(_middleware);

var _actions = require('./actions');

var usageTrackerActions = _interopRequireWildcard(_actions);

var _constants = require('./constants');

var _getTrackPayload = require('./getTrackPayload');

var _getTrackPayload2 = _interopRequireDefault(_getTrackPayload);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.usageTrackerMiddleware = _middleware2.default;
exports.usageTrackerActions = usageTrackerActions;
exports.TRACK_EVENT = _constants.TRACK_EVENT;
exports.getTrackPayload = _getTrackPayload2.default;